module.exports = __webpack_public_path__ + "static/media/BG_vagues_light.0b1bfd1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/BG_vagues_light.png
// module id = 246
// module chunks = 0